import { render, staticRenderFns } from "./DressDetails.vue?vue&type=template&id=09d70f4e&scoped=true"
import script from "./DressDetails.vue?vue&type=script&lang=js"
export * from "./DressDetails.vue?vue&type=script&lang=js"
import style0 from "./DressDetails.vue?vue&type=style&index=0&id=09d70f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d70f4e",
  null
  
)

export default component.exports